import getCookie from 'src/js/utils/get-cookie';
import constants from '../constants';

const getPartnerIdFromStorage = () => {
  const partnerId = getCookie(constants.COOKIE_PARTNER_ID_ITEM);
  return partnerId || null;
};

export default getPartnerIdFromStorage;
